import { ApplicationConfig, importProvidersFrom } from '@angular/core'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { provideRouter } from '@angular/router'
import { BrowserModule } from '@angular/platform-browser'
import { MatDialogModule } from '@angular/material/dialog'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { LayoutModule } from '@angular/cdk/layout'
import { provideFirebaseApp, initializeApp } from '@angular/fire/app'
import { provideDatabase, getDatabase } from '@angular/fire/database'
import { getAuth, provideAuth } from '@angular/fire/auth'
import { provideNativeDateAdapter } from '@angular/material/core'

import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask'
import { DateTimeModule } from 'nxt-pick-datetime'
import { NativeDateTimeModule } from 'nxt-pick-datetime/native-adapter'

import { environment } from '@env'
import { oauthInterceptor } from '@interceptors/oauth-interceptor'
import { contentTypeInterceptor } from '@interceptors/content-type-interceptor'
import { operatorBodyInterceptor } from '@interceptors/operator-body-interceptor'
import { operatorHeadersInterceptor } from '@interceptors/operator-headers-interceptor'
import { debugInterceptor } from '@interceptors/debug-interceptor'
import { verifyTokenFactory } from '@providers/initializer.provider'
import { operatorDataFactory } from '@init-providers/operator-data'

import { APP_ROUTES } from './app.routes'

const maskConfigFunction: () => Partial<NgxMaskConfig> = () => {
	return {
		validation: false,
	}
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(APP_ROUTES),
		importProvidersFrom(
			BrowserModule,
			MatDialogModule,
			MatSnackBarModule,
			LayoutModule,
			DateTimeModule,
			NativeDateTimeModule
		),
		verifyTokenFactory,
		operatorDataFactory,
		provideNativeDateAdapter(),
		provideEnvironmentNgxMask(maskConfigFunction),
		provideAnimations(),
		provideHttpClient(
			withInterceptors([
				oauthInterceptor,
				contentTypeInterceptor,
				operatorBodyInterceptor,
				operatorHeadersInterceptor,
				debugInterceptor,
			])
		),
		provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
		provideDatabase(() => getDatabase()),
		provideAuth(() => getAuth()),
	],
}
